import {
    GET_USERS,
    GET_USERS_SUCCESS,
    GET_USERS_ERROR,
    GET_ACTIVITY_LOGS,
    GET_ACTIVITY_LOGS_SUCCESS,
    GET_ACTIVITY_LOGS_ERROR,
    GET_USER_ACTIVITY,
    GET_USER_ACTIVITY_SUCCESS,
    GET_USER_ACTIVITY_ERROR,
    GET_ACTIVITY_SUMMARY,
    GET_ACTIVITY_SUMMARY_SUCCESS,
    GET_ACTIVITY_SUMMARY_ERROR,
    CLEAR_USER_MANAGEMENT
} from './constants';

const initialState = {
    users: [],
    usersLoading: false,
    usersError: null,
    
    activityLogs: [],
    activityPagination: {
        page: 1,
        limit: 20,
        total: 0,
        pages: 0
    },
    activityLoading: false,
    activityError: null,
    
    userActivity: [],
    userActivityPagination: {
        page: 1,
        limit: 20,
        total: 0,
        pages: 0
    },
    userActivityLoading: false,
    userActivityError: null,
    
    activitySummary: [],
    summaryLoading: false,
    summaryError: null
};

const userManagementReducer = (state = initialState, action) => {
    switch (action.type) {
        // Users
        case GET_USERS:
            return {
                ...state,
                usersLoading: true,
                usersError: null
            };
        case GET_USERS_SUCCESS:
            return {
                ...state,
                usersLoading: false,
                users: Array.isArray(action.payload) ? action.payload : [action.payload],
                usersError: null
            };
        case GET_USERS_ERROR:
            return {
                ...state,
                usersLoading: false,
                usersError: action.payload
            };

        // Activity Logs
        case GET_ACTIVITY_LOGS:
            console.log('[REDUCER] GET_ACTIVITY_LOGS - Setting loading to true');
            return {
                ...state,
                activityLoading: true,
                activityError: null
            };
        case GET_ACTIVITY_LOGS_SUCCESS:
            console.log('[REDUCER] GET_ACTIVITY_LOGS_SUCCESS - Received payload:', action.payload);
            console.log('[REDUCER] Logs count:', action.payload.logs?.length);
            console.log('[REDUCER] Pagination:', action.payload.pagination);
            if (action.payload.logs?.length > 0) {
                console.log('[REDUCER] First log:', action.payload.logs[0]);
            }
            return {
                ...state,
                activityLoading: false,
                activityLogs: action.payload.logs || [],
                activityPagination: action.payload.pagination || initialState.activityPagination,
                activityError: null
            };
        case GET_ACTIVITY_LOGS_ERROR:
            console.log('[REDUCER] GET_ACTIVITY_LOGS_ERROR - Error:', action.payload);
            return {
                ...state,
                activityLoading: false,
                activityError: action.payload
            };

        // User Activity
        case GET_USER_ACTIVITY:
            return {
                ...state,
                userActivityLoading: true,
                userActivityError: null
            };
        case GET_USER_ACTIVITY_SUCCESS:
            return {
                ...state,
                userActivityLoading: false,
                userActivity: action.payload.logs || [],
                userActivityPagination: action.payload.pagination || initialState.userActivityPagination,
                userActivityError: null
            };
        case GET_USER_ACTIVITY_ERROR:
            return {
                ...state,
                userActivityLoading: false,
                userActivityError: action.payload
            };

        // Activity Summary
        case GET_ACTIVITY_SUMMARY:
            return {
                ...state,
                summaryLoading: true,
                summaryError: null
            };
        case GET_ACTIVITY_SUMMARY_SUCCESS:
            return {
                ...state,
                summaryLoading: false,
                activitySummary: action.payload.summary || [],
                summaryError: null
            };
        case GET_ACTIVITY_SUMMARY_ERROR:
            return {
                ...state,
                summaryLoading: false,
                summaryError: action.payload
            };

        // Clear
        case CLEAR_USER_MANAGEMENT:
            return initialState;

        default:
            return state;
    }
};

export default userManagementReducer;
